import {FC, Fragment, useCallback, useEffect, useMemo, useState} from 'react'
import {CsvRow, DataMap} from '..'
import {OptionName} from '../../../AllContactsList/Constant/SelectOption'
import {useSelector} from 'react-redux'
import Select from 'react-select'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {components} from 'react-select'
import FieldPopupModel from '../../../AllContactsList/Modal/FieldPopupModel'
import {validatePhoneNumberRegionWithMessage} from '../../../../../../Utils/_helpers'
import {getDefaultRegion} from '../../../../accounts/Overview/OverviewSlice/UserDetailsSlice'

export type MapDataProps = {
  data: CsvRow[]
  mapped: DataMap[]
  setMapped: (data: DataMap[]) => void
}

type SelectedOption = {
  value: string
  label?: string
  index?: number
}

export type SelectedField = {
  index: number
  name?: string
}

const MapData: FC<MapDataProps> = (props) => {
  const {data, mapped, setMapped} = props
  console.log("🚀 ~ MapData ~ data:", data)

  const dbOptions: string[] =
    useSelector((state: any) => state?.subscriberData?.FieldName?.data?.fields) || []
  const [totalOption, setTotalOption] = useState(OptionName)
  const [totalSelectedOption, setTotalSelectedOption] = useState<string[]>([])

  const [totalOptions, setTotalOptions] = useState<SelectedOption[]>([])
  const [disabledOption, setDisableOption] = useState<SelectedOption[]>([])

  const [newCreateBol, setNewCreateBol] = useState(true)
  const [fieldModel, setFieldModel] = useState(false)
  const [selectedData, setSelectedData] = useState<(SelectedOption | null)[]>([])
  const [selectedField, setSelectedField] = useState<any>({
    inde: 0,
    name: '',
  })

  const userRegion = useSelector(getDefaultRegion)

  const [error, setError] = useState('')

  const findOptionLabel = (selected: string) => {
    return OptionName.find((data) => data.value === selected)?.label
  }

  useEffect(() => {
    const dbOptionsLength = dbOptions?.length || 0
    if (dbOptions !== undefined && dbOptionsLength > 0) {
      let defaultOptions = OptionName?.map((val) => val.value).filter(
        (value) => !dbOptions.includes(value)
      )
      let newOptions = [...dbOptions, ...defaultOptions]
      let unique = newOptions
        .filter((item, i, ar) => ar.indexOf(item) === i)
        ?.map((val) => ({value: val, label: findOptionLabel(val) ?? val}))

      unique?.length >= 30 && setNewCreateBol(false)
      setTotalOption(unique)
      setTotalSelectedOption(dbOptions)
      setTotalOptions(unique)
    } else {
      return
    }

    let arrayOfOption: SelectedOption[] = []
    let mappedDataAuto: any = []
    let selected: SelectedOption[] = []

    const header = data[0]

    header.forEach((val, index) => {
      const sampleData = data?.length > 1 ? data[1] : []
      const checkNumberIndex = sampleData[index]

      const validateNumber = validatePhoneNumberRegionWithMessage({
        number: checkNumberIndex,
        region: userRegion,
        validateDuplicate: false,
        contacts: new Map(),
      })
      if (validateNumber.isValid) {
        const checkIsNumberIndex = sampleData.findIndex(
          (it: string) =>
            validatePhoneNumberRegionWithMessage({
              number: it,
              region: userRegion,
              validateDuplicate: false,
              contacts: new Map(),
            }).isValid
        )

        if (checkIsNumberIndex === index) {
          arrayOfOption?.push({value: 'mobile number', index: index})
          mappedDataAuto?.push({oldLabel: val, newLabel: 'mobile number'})
        }
      }

      let autoSelectedOption = totalOption?.find(
        (key: any) =>
          key?.value?.replace(/\s/g, '')?.toLowerCase() === val?.replace(/\s/g, '')?.toLowerCase()
      )

      if (autoSelectedOption) {
        arrayOfOption?.push({
          value: autoSelectedOption?.value,
          label: autoSelectedOption.label,
          index: index,
        })
        mappedDataAuto?.push({oldLabel: val, newLabel: autoSelectedOption.value})
        selected?.push({...autoSelectedOption, index})
      }
    })

    setDisableOption([...disabledOption, ...arrayOfOption])
    setMapped(mappedDataAuto)
  }, [data, dbOptions])

  let isAutoSelectedOption = useCallback(
    (val: string, index: number) =>
      totalOption?.find((key) => {
        const validateNumber = validatePhoneNumberRegionWithMessage({
          number: data?.length > 1 ? data[1][index] : '',
          region: userRegion,
          validateDuplicate: false,
          contacts: new Map(),
        })

        if (validateNumber.isValid) {
          const checkIsNumberIndex = data[1].findIndex(
            (it: string) =>
              validatePhoneNumberRegionWithMessage({
                number: it,
                region: userRegion,
                validateDuplicate: false,
                contacts: new Map(),
              }).isValid
          )

          if (checkIsNumberIndex === index) {
            return key?.value?.replace(/\s/g, '')?.toLowerCase() === 'mobilenumber'
          }
          return false
        } else {
          let x =
            key?.value?.replace(/\s/g, '')?.toLowerCase() === val?.replace(/\s/g, '')?.toLowerCase()
          return x
        }
      }),
    [data, totalOption]
  )

  const handleSelect = (selectedValue: SelectedOption, index: number) => {
    //validation birthday
    if (['Birthday', 'birthday'].includes(selectedValue?.value)) {
      let normalDateParts = []
      const birthday = data.at(1)?.at(index)
      if (birthday?.includes('-')) normalDateParts = birthday.split('-')
      if (!normalDateParts.length) {
        setError('Wrong birthday format it should have this format 25-03-2000')
        return
      }
    } else {
      setError('')
    }

    // Function to remove the selected option
    const removeSelectedOption = (value: string) => {
      const updatedDisabledOptions = disabledOption.filter((option) => option.value !== value)
      setDisableOption(updatedDisabledOptions)

      const indexOfMapped = mapped.findIndex((item) => item.newLabel === value)
      if (indexOfMapped !== -1) {
        mapped.splice(indexOfMapped, 1)
        setMapped([...mapped])

        if (dbOptions && !dbOptions.includes(value)) {
          const updatedTotalSelectedOption = totalSelectedOption.filter(
            (item: any) => item !== value
          )
          updatedTotalSelectedOption?.length >= 30 && setNewCreateBol(false)
          setTotalSelectedOption(updatedTotalSelectedOption)
        }
      }

      let tempData = [...selectedData]
      tempData[index] = null
      setSelectedData(tempData)
    }

    if (!selectedValue) {
      const nameOfRemoveOption = disabledOption.find((val) => val.index === index)?.value
      if (nameOfRemoveOption) {
        removeSelectedOption(nameOfRemoveOption)
      }
    } else {
      // Check if the selected option is already disabled
      const isOptionDisabled = disabledOption.find((option: any) => option.index === index)

      // If it's disabled, update it; otherwise, add it to disabled options
      if (isOptionDisabled) {
        const updatedDisabledOptions = disabledOption.map((option: any) =>
          option.index === index ? {value: selectedValue.value, index} : option
        )
        setDisableOption(updatedDisabledOptions)
      } else {
        setDisableOption([...disabledOption, {value: selectedValue.value, index}])
      }

      // Add the selected option to totalSelected if it's not already there
      if (!totalSelectedOption.includes(selectedValue.value)) {
        setTotalSelectedOption([...totalSelectedOption, selectedValue.value])
      }

      // Map oldLabel and newLabel and store it
      const indexOfMappedOldLabel = mapped.findIndex(
        (item: any) => item.oldLabel === data[0][index]
      )

      if (indexOfMappedOldLabel === -1) {
        if (selectedValue.value === 'mobile number') {
          setMapped([...mapped, {oldLabel: data[0][index], newLabel: 'mobile number'}])
        } else {
          setMapped([...mapped, {oldLabel: data[0][index], newLabel: selectedValue.value}])
        }
      } else {
        // Remove and update the disabled option
        const indexOfDisabledOption = disabledOption.findIndex(
          (option: any) => option.index === index
        )
        disabledOption.splice(indexOfDisabledOption, 1)
        setDisableOption([...disabledOption, {value: selectedValue.value, index}])

        // Update oldLabel mapped data with newLabel data
        mapped.splice(indexOfMappedOldLabel, 1)
        setMapped([...mapped, {oldLabel: data[0][index], newLabel: selectedValue.value}])
      }
      let tempData = selectedData ?? []
      tempData[index] = {value: selectedValue.value, label: selectedValue.value}
      setSelectedData(tempData)

      let tempOptionsData = totalOptions ?? []

      if (!tempOptionsData?.some((data: {value: string}) => data?.value == selectedValue.value)) {
        tempOptionsData = [
          ...tempOptionsData,
          {value: selectedValue.value, label: selectedValue.value},
        ]
      }

      if (tempOptionsData?.length >= 30) setNewCreateBol(false)
      setTotalOptions(tempOptionsData)
    }
  }

  const FieldPopup = useMemo(
    () => (
      <FieldPopupModel
        show={fieldModel}
        handleClose={(name: any = {}) => {
          handleSelect(name, selectedField.index)
          setFieldModel(false)
        }}
      />
    ),
    [fieldModel]
  )

  const SelectItems = (props: any) => {
    const {index, newCreateBol, ...rest} = props
    return (
      <components.MenuList {...rest}>
        {props.children}
        <OverlayTrigger
          placement='top'
          overlay={<Tooltip id='button-tooltip'>Create new field</Tooltip>}
        >
          <div>
            {newCreateBol ? (
              <div
                className='select-create-button'
                onClick={() => {
                  setFieldModel(true)
                  setSelectedField({index})
                }}
              >
                <i className='bi bi-plus-lg'></i>
                <p>Create new</p>
              </div>
            ) : null}
          </div>
        </OverlayTrigger>
      </components.MenuList>
    )
  }

  useEffect(() => {
    let tempData: any[] = []
    tempData = data?.[0].map((val, index: number) => {
      /////Logic for auto select option
      return totalOption?.find((key: any) => {
        const validateNumber = validatePhoneNumberRegionWithMessage({
          number: data?.length > 1 ? data[1][index] : '',
          region: userRegion,
          validateDuplicate: false,
          contacts: new Map(),
        })

        if (validateNumber.isValid) {
          const checkIsNumberIndex = data[1].findIndex(
            (it: string) =>
              validatePhoneNumberRegionWithMessage({
                number: it,
                region: userRegion,
                validateDuplicate: false,
                contacts: new Map(),
              }).isValid
          )

          if (checkIsNumberIndex === index) {
            return key?.value?.replace(/\s/g, '')?.toLowerCase() === 'mobilenumber'
          }
          return false
        } else {
          let x =
            key?.value?.replace(/\s/g, '')?.toLowerCase() == val?.replace(/\s/g, '')?.toLowerCase()
          return x
        }
      })
    })
    setSelectedData(tempData)
  }, [data, totalOption])

  return (
    <>
      {FieldPopup}
      {data[0].map((val, index1) => {
        let autoSelectedOption = isAutoSelectedOption(val, index1)

        return (
          <div className='row justify-content-start mb-5 mt-10 custome-fields' key={index1}>
            <div className='col-4'>
              {data?.map(
                (val: any, index2: number) =>
                  index2 < 4 && (
                    <Fragment key={index2}>
                      {index2 === 0 ? (
                        <>
                          {val?.map((key: any, index3: number) => (
                            <Fragment key={index3}>
                              {index3 === index1 && (
                                <h3
                                  className='fs-7'
                                  style={{
                                    color: '#232323',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                  }}
                                >
                                  {key}
                                </h3>
                              )}
                            </Fragment>
                          ))}
                        </>
                      ) : (
                        <>
                          {val?.map((key: any, index4: number) => (
                            <Fragment key={index4}>
                              {index4 === index1 && (
                                <li
                                  className='list-unstyled fs-7'
                                  style={{
                                    color: '#A2A5B5',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                  }}
                                >
                                  {key}
                                </li>
                              )}
                            </Fragment>
                          ))}
                        </>
                      )}
                    </Fragment>
                  )
              )}
            </div>
            <div className='col-8'>
              <label className='mb-2'>Select a field</label>
              <Select
                classNamePrefix='createBox'
                className='select_create react-tags-fieldBox selectbox-create-custom'
                components={{
                  MenuList: (props) => (
                    <SelectItems index={index1} newCreateBol={newCreateBol} {...props} />
                  ),
                }}
                onChange={(e: any) => {
                  handleSelect(e, index1)
                }}
                isOptionDisabled={(option: any) => {
                  let d = disabledOption.map((val: any) => val.value)
                  return d?.includes(option.value)
                }}
                value={selectedData?.[index1] ?? null}
                defaultValue={autoSelectedOption}
                options={totalOptions ?? []}
                isClearable
              />
            </div>
          </div>
        )
      })}
      <span className='text-danger mx-15'>{error}</span>
    </>
  )
}

export default MapData
